import TextField from "@material-ui/core/esm/TextField";
import Box from "@material-ui/core/esm/Box";
import { nanoid } from 'nanoid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DialogComponent from 'components/Dialog/Dialog';
import { FormElement } from 'components/Form';
import { Subtitle } from 'components/Text';
import useGetValidationStrings from 'hooks/language/useGetValidationString';
import useActivateAccess from 'hooks/privileges/useActivateAccess';
import isValidEmail from 'utils/text/isValidEmail';
const idSuffix = nanoid();
export default function ActivateAccessDialog({
  open,
  onClose
}) {
  const {
    t
  } = useTranslation();
  const [emailAddress, setEmailAddress] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const {
    emailFormat
  } = useGetValidationStrings();
  const {
    isLoading,
    activateAccess
  } = useActivateAccess();
  const handleEmailInputChange = event => {
    const {
      value
    } = event.target;
    setEmailAddress(value);
    setShowErrorMessage(!isValidEmail(value));
  };
  const handleClose = () => {
    setEmailAddress('');
    setShowErrorMessage(false);
    onClose();
  };
  const handleButtonClick = async () => {
    await activateAccess(emailAddress);
    handleClose();
  };
  const inputFieldId = `email_input_${idSuffix}`;
  return /*#__PURE__*/React.createElement(DialogComponent, {
    open: open,
    onClose: onClose,
    dialogTitle: t('customers.activate_access'),
    primaryBtnTitle: t('customers.send_activation_link'),
    primaryBtnClickIsDisabled: !emailAddress || !isValidEmail(emailAddress),
    onPrimaryBtnClick: handleButtonClick,
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Subtitle, null, t('customers.enter_email'))), /*#__PURE__*/React.createElement(FormElement, {
    title: t('customers.email'),
    childId: inputFieldId
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    onChange: handleEmailInputChange,
    inputProps: {
      id: inputFieldId
    },
    placeholder: t('customers.email'),
    error: showErrorMessage,
    helperText: showErrorMessage && emailFormat
  })));
}